import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=08f6c37c&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=08f6c37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6c37c",
  null
  
)

export default component.exports